import styled from 'styled-components';
import { HR } from '@zillow/zrs-comet';

export const StyledHR = styled(HR)`
  width: 142px;
`;
